
import { ClientSearch } from "./ClientSearch";
import { SearchResult } from "@/types/client-search";
import AdminMenu from "./AdminMenu";

interface AdminSectionProps {
  showSearch: boolean;
  onClientSelect: (client: SearchResult) => void;
}

export const AdminSection = ({ showSearch, onClientSelect }: AdminSectionProps) => {
  return (
    <div>
      <AdminMenu />
      {showSearch && (
        <div className="mt-4">
          <ClientSearch onClientSelect={onClientSelect} />
        </div>
      )}
    </div>
  );
};
